import moment from "moment"
import React, { useEffect, useState } from "react"
import { Col, Input, Label, Modal, Row } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import DynamicForm from "components/custom/DynamicForm/View/DynamicForm"
import AlternativeConfigFieldViewOnly from "./AlternativeConfigFieldViewOnly"
import DynamicFormViewOnly from "components/custom/DynamicForm/View/ViewOnly/DynamicFormViewOnly"

const GovernanceSectionViewOnly = ({
  alternativeId,
  alternative,
  scenario,
  fieldConfigItems,
  sectionFormId,

  brmLabel,
  advancedPlanningLabel,
  investmentCategoryLabel,
  lbrLabel,
  planningCategoryLabel,
  ldoLabel,
  planningStageLabel,
}) => {
  const currentUser = userService.getLoggedInUser()
  const [userOptions, setUserOptions] = useState([])
  const [leadDeliveryOptions, setLeadDeliveryOptions] = useState([])
  const [workflowOptions, setWorkflowOptions] = useState([])
  const [investmentOptions, setInvestmentOptions] = useState([])
  const [businessCaseOptions, setBusinessCaseOptions] = useState([])
  const [planningOptions, setPlanningOptions] = useState([])
  const [alternativePhases, setAlternativePhases] = useState([])
  const [advancedPlanningOptions, setAdvancedPlanningOptions] = useState([])
  const [cpPhaseOptions, setCpPhaseOptions] = useState([])
  const [isManageModalOpen, setIsManageModalOpen] = useState(false)
  const toggleManageModal = () => setIsManageModalOpen(!isManageModalOpen)
  const [userAlternativeAccess, setUserAlternativeAccess] = useState([])
  const [programs, setPrograms] = useState([])
  const [changeRequestTasks, setChangeRequestTasks] = useState([])

  // useEffect(() => {
  //   if (alternativeId > 0) {
  //     loadData()
  //     loadChangeRequestTasks()
  //   }
  // }, [alternativeId])

  const loadChangeRequestTasks = async () => {
    let t = await api.getGeneralTasks(
      1,
      "Alternatives",
      alternativeId,
      currentUser.userID
    )
    setChangeRequestTasks(t)
  }

  const loadData = async () => {
    api.getScenarioList(alternative.scenarioID, "UserList").then(usrs => {
      setUserOptions(usrs)
    })
    api.getScenarioList(alternative.scenarioID, "LDO").then(leads => {
      setLeadDeliveryOptions(leads)
    })
    api
      .getScenarioList(alternative.scenarioID, "WorkflowStatus")
      .then(workflows => {
        setWorkflowOptions(workflows)
      })
    api.getList(currentUser.userID, "CPICPhase").then(cp => {
      setCpPhaseOptions(cp)
    })
    api.getScenarioList(alternative.scenarioID, "AdvancedPlanning").then(ap => {
      setAdvancedPlanningOptions(ap)
    })
    api.getList(currentUser.userID, "BCStatus").then(business => {
      setBusinessCaseOptions(business)
    })
    api
      .getScenarioList(alternative.scenarioID, "PlanningCategory")
      .then(plans => {
        setPlanningOptions(plans)
      })
    // let phs = await api.getList(currentUser.userID, "ProjectPhase")
    // setProjectPhaseOptions(phs)
    api.getPrograms(scenario.enterpriseID).then(p => {
      setPrograms(p)
    })
    api
      .getScenarioList(alternative.scenarioID, "AlternativePhase")
      .then(aph => {
        setAlternativePhases(aph)
      })

    api
      .getScenarioList(alternative.scenarioID, "InvestmentCategory")
      .then(invopt => {
        setInvestmentOptions(invopt)
      })
  }

  const loadUserAlternativeAccess = async () => {
    let data = await api.getUserAlternativeAccessData(
      alternative.scenarioID,
      alternativeId
    )
    setUserAlternativeAccess(data)
  }

  return (
    <React.Fragment>
      {sectionFormId != 0 && (
        <>
          <Row>
            <Col md="12">
              <div className="divider"></div>
              <DynamicFormViewOnly
                formId={sectionFormId}
                itemId={alternative?.alternativeID}
                scenarioId={alternative?.scenarioID}
              />
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  )
}

export default GovernanceSectionViewOnly
